import { Typography, type TypographyProps, useTheme } from '@mui/material';
import { Fragment } from 'react';

interface HighlightedTextProps extends Omit<TypographyProps, 'children'> {
  text: string;
  searchTerm: string;
}

export const HighlightedText = ({ text, searchTerm, ...typographyProps }: HighlightedTextProps) => {
  const theme = useTheme();

  if (!searchTerm.trim()) {
    return <Typography {...typographyProps}>{text}</Typography>;
  }

  const parts = text.split(new RegExp(`(${searchTerm})`, 'gi'));

  return (
    <Typography {...typographyProps}>
      {parts.map((part, index) => (
        <Fragment key={index}>
          {part.toLowerCase() === searchTerm.toLowerCase() ? (
            <span
              style={{
                color: theme.palette.primary.main,
                fontWeight: 'bold',
              }}
            >
              {part}
            </span>
          ) : (
            part
          )}
        </Fragment>
      ))}
    </Typography>
  );
};
